import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    div:last-child {
        margin-left: 21px;
    }

    p:last-child {
        font-size: 14px;
    }

    ${mq.gt.md} {
        max-width: 244px;
    }
`;
